import { render } from "./Step.vue?vue&type=template&id=3a26640c&scoped=true&ts=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"

import "./Step.vue?vue&type=style&index=0&id=3a26640c&scoped=true&lang=scss"

import exportComponent from "D:\\projects\\tmp\\ball-falling-steps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a26640c"]])

export default __exports__